
import { library } from '@fortawesome/fontawesome-svg-core'
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome'
import {
  faBuildingColumns,
  faChevronLeft, faChevronRight, faCircleQuestion, faCreditCard,
  faQuestion,
} from '@fortawesome/free-solid-svg-icons'

import Box from '@mui/material/Box'
import Checkbox from '@mui/material/Checkbox'
import FormControlLabel from '@mui/material/FormControlLabel'
import Switch from '@mui/material/Switch'
import TabContext from '@mui/lab/TabContext'

import { useMatomo } from '@jonkoops/matomo-tracker-react'

import React, { Fragment as F, useContext, useEffect, useLayoutEffect, useState } from 'react'
import { useKeycloak } from '@react-keycloak/web'
import Modal from 'react-modal'
import Select from 'react-select'
import { useNavigate } from "react-router-dom"
import { toast } from 'react-toastify'
import OverlayTrigger from 'react-bootstrap/OverlayTrigger'
import Tooltip from 'react-bootstrap/Tooltip'

import PropTypes from 'prop-types'


import {
  appRouter,
  C,
  defaultFintegrationQueryTmpl,
  logg, loggt,
  useApiRouter,
} from "$shared"

import {
  AppCtx,
} from '$src/App'
import {
  QueriesCtx,
} from '$src/components/queries'
import {
  SchedulesCtx,
} from '$src/components/schedules'

import {
  BanksCtx,
  Criteria,
  operator,

  Tab, TabList, TabPanel,
} from '$src/components/banks'

import {
  FintegrationCtx,
} from '$src/components/fintegration'

library.add(
  faBuildingColumns,
  faChevronLeft, faChevronRight, faCircleQuestion, faCreditCard,
  faQuestion,
);

// const defaultLabels = ["Bank_RSSD", "Bank_Cert", "Bank_Name", "Bank_Address", "Bank_City",
// "Bank_State", "Total_Assets", "Core_Vendor", "Online_Vendor", "Business_Online_Vendor",
// "Online_New_Account_Opening", "Credit_Card_Issuer", "Credit_Card_Type", "Debit_Processor",
// "Merchant_Services_Processor", "P2P_Vendor", "Rewards", "Mobile_Vendor", "Credit_Processor",
// "Online_Auto_Loan_Origination_System", "Debit_Card_Type", "Online_Mortgage_Loan_Origination_System", "Bill_Pay_Vendor"]

/*
 * FintegrationResultsModal
**/
const FintegrationResultsModal = (props) => {
  // logg(props, 'FintegrationResultsModal')

  /* ctx */

  const apiRouter = useApiRouter()
  const navigate  = useNavigate()
  const { trackPageView, trackEvent } = useMatomo()

  const {
    actionName, setActionName,
    jwtToken,
    loading,    setLoading,
    statesList,
  } = useContext(AppCtx)
  // logg(useContext(AppCtx), 'AppCtx in FintegrationResults')

  const {
  } = useContext(BanksCtx)
  // logg(useContext(BanksCtx), 'BanksCtx in FintegrationResults')

  const {
    fintegrationResults,
    fintegrationResultsModalOpen, setFintegrationResultsModalOpen,
    labels, setLabels,
    query,         setQuery,
    results,       setResults,
  } = useContext(FintegrationCtx)
  // logg(useContext(FintegrationCtx), 'FintegrationCtx in FintegrationResults')

  /* sort */
  const [ sortKey, setSortKey ] = useState('name_i')
  const [ sortDir, setSortDir ] = useState(C.asc)
  const [ sortedFintegrationResults, setSortedFintegrationResults ] = useState(fintegrationResults)
  useEffect(() => {
    const tmp = [...fintegrationResults]
    tmp.sort((a, b) => {
      if (sortKey===6) { // total assets
        if ( Number(a[sortKey]) < Number(b[sortKey]) ) {
          return sortDir === C.asc ? -1 : 1
        } else {
          return sortDir === C.asc ? 1 : -1
        }

      } else {
        if (a[sortKey] < b[sortKey]) {
          return sortDir === C.asc ? -1 : 1
        } else {
          return sortDir === C.asc ? 1 : -1
        }
      }
    })
    setSortedFintegrationResults(tmp)
  }, [ sortKey, sortDir, fintegrationResults ])

  return <Modal
    ariaHideApp={false}
    className="FintegrationResultsModal BaseModal"
    isOpen={fintegrationResultsModalOpen}
    onRequestClose={ () => setFintegrationResultsModalOpen(false) }
    overlayClassName="ModalOverlay ModalOverlay-z10"
  >
    <div className='modal-header'>
      <h5>Fintegration Results</h5>
      <div className='close' onClick={() => setFintegrationResultsModalOpen(false)} >&times;</div>
    </div>
    <div className='modal-body'>
      <div className='modal-bodyC'>
        <table className='FintegrationResults bordered dataTable' >
          <thead>
            <tr>
              { labels.map((label, idx) =>
                <th key={idx} className={`dt-orderable-asc dt-orderable-desc ${idx === sortKey ? sortDir === C.asc ? 'dt-ordering-asc' : 'dt-ordering-desc' : ''}`}
                  onClick={() => {
                    if (sortKey === idx) {
                      setSortDir(sortDir === C.asc ? C.desc : C.asc)
                    }
                    setSortKey(idx)
                  } }
                  >{ label }<span className='dt-column-order'></span>
                </th> )}
            </tr>
          </thead>
          <tbody>
            { sortedFintegrationResults.map((row, idx) => <tr key={idx}>
              { row.map((item, idx) => <td key={idx}>{idx === 6 ? Number(item.split('.')[0]).toLocaleString('en-US') : item }</td> )}
            </tr> )}
          </tbody>
        </table>
      </div>
    </div>
    <div className="actions">
      <div className='left'></div>
      <div className='right m-1'>
        <form method="post" action={ apiRouter.fintegrationRunPath({ format: 'csv' }) } >
          <input type="hidden" name="query" value={JSON.stringify(query)} />
          <input type='submit' className='Btn btn-primary' value='Export CSV'></input>
        </form>
      </div>
    </div>
  </Modal>
}
export default FintegrationResultsModal

